import {DictionaryUtil} from '../../../utils/DictionaryUtil';
import { BasicConstants } from "../../constants/BasicConstants";
import { BasicModel } from "../BasicModel";
import { BasicLayoutManager } from "../../view/BasicLayoutManager";
import { CommonDialogNames } from "../../view/CommonDialogNames";
import { BasicStandardOkDialogProperties } from "../../view/dialogs/BasicStandardOkDialogProperties";
import { Timer } from "@goodgamestudios/createjs-utilities";

import TimerEvent = createjs.TimerEvent;

export class BasicSessionData {
    protected _currentEvents: any[] = [0];
    protected _loggedinTimer: Timer;
    protected _loggedinTime: number;
    protected _loggedinTimeMsgId: number;
    protected _sessionTimerDict: Map<any, any>;
    private _loggedIn: boolean;

    public get currentEvents(): any[] {
        return this._currentEvents;
    }

    public set currentEvents(value: any[]) {
        this._currentEvents = value;
    }

    public isEventActive(eventID: string): boolean {
        for (let event of this._currentEvents) {
            if (event == eventID) {
                return true;
            }
        }
        return false;
    }

    /**
     * Set logintime and start timer
     * loggedInTime: minutes
     * interval: secounds
     */
    public initLoggedinTime(loggedInTime: number, interval: number = 0): void {
        if (interval == 0) {
            interval = BasicConstants.LOGGEDIN_MESSAGE_TIME_INTERVAL;
        }

        this._loggedinTime = loggedInTime;
        this._loggedinTimeMsgId = this._loggedinTime * 60000 / interval;

        this.resetLoggedinTimer();
        this._loggedinTimer = new Timer(interval, 1);
        this._loggedinTimer.addEventListener(TimerEvent.TIMER_COMPLETE, this.bindFunction(this.onLoggedinMessageTimerComplete));
        this._loggedinTimer.start();
    }

    public resetLoggedinTimer(): void {
        if (this._loggedinTimer) {
            this._loggedinTimer.removeEventListener(TimerEvent.TIMER_COMPLETE, this.bindFunction(this.onLoggedinMessageTimerComplete));
        }
    }

    protected onLoggedinMessageTimerComplete(event: TimerEvent): void {
        this._loggedinTimer.reset();
        this._loggedinTime += BasicConstants.LOGGEDIN_MESSAGE_TIME_INTERVAL;
        this._loggedinTimeMsgId++;
        let title: string = BasicModel.languageData.getTextById("alert_logintimemsg_title_" + this._loggedinTimeMsgId);
        let copy: string = BasicModel.languageData.getTextById("alert_logintimemsg_copy_" + this._loggedinTimeMsgId);

        if (title.length > 0 && copy.length > 0) {
            this.showLoggedinTimeIntervalMessage(title, copy);
        }

        this._loggedinTimer.start();
    };

    public /*final*/ showLoggedinTimeIntervalMessage(title: string, copy: string): void {
        BasicLayoutManager.getInstance().showDialog(CommonDialogNames.StandardOkDialog_NAME, new BasicStandardOkDialogProperties(title, copy));
    }

    public initSessionTime(interval: number, timerId: string): void {
        //			resetSessionTimer();
        if (this._sessionTimerDict == null) {
            this._sessionTimerDict = new Map<any, any>();
        }

        let timer: Timer = new Timer(interval, 1);
        timer.addEventListener(TimerEvent.TIMER_COMPLETE, this.bindFunction(this.onSessionTimerComplete));
        this._sessionTimerDict.set(timerId, timer);
        timer.start();
    }

    public resetSessionTimer(): void {
        if (this._sessionTimerDict) {
            for (let timer in this._sessionTimerDict.values())
                this._sessionTimerDict[timer].removeEventListener(TimerEvent.TIMER_COMPLETE, this.bindFunction(this.onSessionTimerComplete));
        }
    }

    public isSessionTimerById(timerId: string, timer: Timer): boolean {
        if (DictionaryUtil.containsKey(this._sessionTimerDict, timerId)) {
            if (this._sessionTimerDict.get(timerId) == timer) {
                return true;
            }
        }
        return false;
    }

    protected onSessionTimerComplete(event: TimerEvent): void {
        event.target.reset();
        //			_sessionTimer.reset();
        //			_sessionTimer.start();
    };

    public get loggedIn(): boolean {
        return this._loggedIn;
    }

    public set loggedIn(value: boolean) {
        this._loggedIn = value;
    }
}
